import React from 'react'
import { Form, Button } from 'react-bootstrap';
const ClickVendas = (props)=>{
  const {change, updateQtde, name, index, qtde } = props
  return(<form>
    <label>Atualizar Pedido </label>
    <input id={name} type="number" style={{width: 100}} onChange={change} /><br />
    <Button variant="primary" type="submit" onClick={() => updateQtde(index, qtde)}>
      Adicionar ao pedido
    </Button>
  </form>)
}
export default ClickVendas
